import { Injectable } from "@angular/core";
import { AuthenticatedUser } from "../../shared/models/auth";
import { StoreBase } from "../../shared/models/bases";

@Injectable({
  providedIn: 'root'
})

export class AuthenticatedUserStore extends StoreBase<AuthenticatedUser> { }
